import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Box, Button, Container, Grid, Card, CardContent, Stack, Chip, Skeleton} from 'views/components';
import {Translate} from 'views/module';

import JobBoardTitle from './JobBoardTitle';
import {parseJobData} from './util';
import JobCardSkeleton from '../../components/JobCardSkeleton';

const JobListings = (props) => {
  const {jobs, isLoading} = props;
  let jobList = [];
  if (!isLoading) jobList = jobs.list;
  else for (let i = 0; i < 6; i++) jobList.push([]); // Add placeholder cards when loading

  return (
    <Box
      component="main"
      flex="1 1 0%"
      display="block"
      sx={{
        position: 'relative',
        flexGrow: 1,
      }}
    >
      <JobBoardTitle/>
      <Box sx={{py: 6}}>
        <Container maxWidth={false}>
          <Box sx={{maxWidth: 1700, mx: 'auto'}}>
            {/* Grid header*/}
            <Box sx={{textAlign: 'center', mb: 4}}>
              {
                isLoading ?
                <Skeleton
                  variant="text"
                  width={260}
                  sx={{mx: 'auto'}}
                /> :
                <Typography variant="h5" fontWeight={600}>
                  <Translate expression='jobBoard.JobListings.PositionsAvailable' substitute={{length: jobList.length}}/>
                </Typography>
              }
              <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
                <Translate expression='jobBoard.JobListings.FindPerfectCaregiving'/>
              </Typography>
            </Box>
            {/* Main Grid for the job postings */}
            <Grid container spacing={3} justifyContent='center'>
              {/* Card display: loading */}
              {
                isLoading &&
                jobList.map((_, i) => (
                  <Grid size={{xs: 12, md: 6, lg: 4}} key={i}>
                    <JobCardSkeleton/>
                  </Grid>
                ))
              }
              {/* Card display: content */}
              {
                !isLoading &&
                jobList.map((job) => {
                  const location = job.location;
                  const jobDataParsed = parseJobData(job);

                  return (
                    <Grid size={{xs: 12, md: 6, lg: 4}}
                      sx={{
                        flexGrow: 0,
                        flexBasis: 500,
                        maxWidth: 500,
                        display: 'flex',
                      }}
                      key={job.jobRn}
                    >
                      <Card
                        variant="outlined"
                        sx={{
                          'borderRadius': 3,
                          'height': '100%',
                          'width': '100%',
                          'display': 'flex',
                          'flexDirection': 'column',
                        }}
                      >
                        <CardContent
                          sx={{
                            p: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            minHeight: 0,
                          }}
                        >
                          <Stack spacing={2}>
                            <Box>
                              <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}>
                                <Typography
                                  variant="h7"
                                  fontWeight={600}
                                  pr={5}
                                >
                                  <Translate expression='jobBoard.JobListings.JobTitle'
                                    substitute={{
                                      neighborhood: location.neighborhood,
                                      city: location.city,
                                    }}
                                  />
                                </Typography>
                                <Typography
                                  variant="h7"
                                  fontWeight={600}
                                >
                                  {jobDataParsed.payPerWeekString}
                                </Typography>
                              </Box>
                              <Typography variant="body2"
                                color="text.secondary"
                                sx={{
                                  mt: 0.5,
                                  display: '-webkit-box',
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                }}>
                                {job.description.short}
                              </Typography>
                            </Box>

                            <Box height='inherit'>
                              <Typography variant="body2" color="text.secondary" fontWeight={500} sx={{height: 'inherit'}}>
                                {jobDataParsed.salaryInfo}
                              </Typography>
                            </Box>

                            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                              {
                                jobDataParsed.scheduleStringsFormated.map((s, i) => {
                                  return (
                                    <Chip
                                      key={i}
                                      variant="outlined"
                                      label={s}
                                      sx={{
                                        'borderRadius': 999,
                                        'borderColor': 'rgba(0,0,0,0.12)',
                                        'bgcolor': '#fff',
                                        'px': 0.75,
                                        '& .MuiChip-label': {
                                          py: 0.5,
                                          fontSize: 14,
                                          color: 'rgba(0,0,0,0.70)',
                                        },
                                      }}
                                    />
                                  );
                                })
                              }
                            </Stack>
                          </Stack>
                          <Box sx={{mt: 'auto', display: 'flex', justifyContent: 'flex-end'}}>
                            <Button
                              variant='contained'
                              href={`/job/${job.jobRn}`}
                              sx={{
                                'bgcolor': '#000',
                                'borderRadius': 999,
                                'mt': 1,
                                'textTransform': 'none',
                                'fontWeight': 600,
                              }}
                            >
                              <Translate expression='jobBoard.JobListings.ViewDetails'/>
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })
              }
            </Grid>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

JobListings.propTypes = {
  jobs: PropTypes.shape({
    lastEvaluatedKey: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
  isLoading: PropTypes.bool.isRequired,
};

export default JobListings;
